import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import IconFreska from 'assets/images/icon-freska.svg';

import { logout, getActiveCustomer, hasMultipleCustomers } from 'store/auth';
import { switchCustomer } from 'store/customers';
import { getReferralCoupon } from 'store/referralCoupon';

import { NavigationLink } from 'components';

export class Navigation extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    activeCustomer: PropTypes.object.isRequired,
    hasMultipleCustomers: PropTypes.bool.isRequired,
    referralCoupon: PropTypes.object,
    onClickLogout: PropTypes.func.isRequired,
    onClickSwitchAccount: PropTypes.func.isRequired
  };

  static defaultProps = {
    referralCoupon: null
  };

  handleClickLogout = event => {
    this.props.onClickLogout();

    event.preventDefault();
  };

  handleClickSwitchAccount = event => {
    this.props.onClickSwitchAccount();

    event.preventDefault();
  };

  getNavigationItems() {
    return [
      {
        to: '/overview',
        title: 'navigation.overview',
        hasBreak: !this.props.referralCoupon,
        isRendered: true
      },
      {
        to: '/get-discount',
        title: 'navigation.getDiscount',
        hasBreak: true,
        isRendered: this.props.referralCoupon
      },
      {
        to: '/account',
        title: 'navigation.account',
        hasBreak: false,
        isRendered: true
      },
      {
        to: '/payment-method',
        title: 'navigation.paymentMethod',
        hasBreak: true,
        isRendered: true
      },
      {
        to: '/contact',
        title: 'navigation.contact',
        hasBreak: false,
        isRendered: true
      },
      {
        to: '/help',
        title: 'navigation.help',
        hasBreak: false,
        isRendered: true
      }
    ];
  }

  renderNavigation() {
    return this.getNavigationItems().map(
      item =>
        item.isRendered ? (
          <li key={item.to}>
            <NavigationLink to={item.to} hasBreak={item.hasBreak}>
              {this.props.t(item.title)}
            </NavigationLink>
          </li>
        ) : null
    );
  }

  render() {
    return (
      <nav className="navigation">
        <div className="navigation__brand">
          <img className="navigation__logo" src={IconFreska} alt="MyFreska" />
        </div>

        <ul className="navlist">
          {this.renderNavigation()}

          <li>
            <NavigationLink onClick={this.handleClickLogout}>
              {this.props.t('navigation.logout')}
            </NavigationLink>
          </li>

          {this.props.hasMultipleCustomers && (
            <li className="navlist__extra">
              <NavigationLink onClick={this.handleClickSwitchAccount}>
                {this.props.t('navigation.switchAccount')}
                <br />
                <span className="navlist__meta">
                  <strong>{this.props.t('navigation.current')}:</strong>{' '}
                  {this.props.activeCustomer.name}
                </span>
              </NavigationLink>
            </li>
          )}
        </ul>
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  activeCustomer: getActiveCustomer(state),
  hasMultipleCustomers: hasMultipleCustomers(state),
  referralCoupon: getReferralCoupon(state)
});

const mapDispatchToProps = {
  onClickLogout: logout,
  onClickSwitchAccount: switchCustomer
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(translate()(Navigation))
);



// WEBPACK FOOTER //
// ./src/containers/Navigation/Navigation.js